import { COLORS } from '@/styles/color';
import { FONT_WEIGHTS } from '@/styles/typography';
import { customTextSize } from '@/styles/typography/utils';
import styled from 'styled-components';

const StyledList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

const ListItem = styled.li`
  display: flex;
  align-items: flex-start;
  gap: 8px;
  ${customTextSize(15, 20)};
  font-weight: ${FONT_WEIGHTS.MEDIUM};
  color: ${COLORS.BLACK};
`;

interface CheckMarkListProps {
  items: string[];
}

export const CheckMarkList = ({ items }: CheckMarkListProps) => (
  <StyledList>
    {items.map((item, index) => (
      <ListItem key={index}>
        <CheckMark />
        {item}
      </ListItem>
    ))}
  </StyledList>
);

const CheckMark = () => {
  return (<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
    <g clip-path="url(#clip0_4174_9883)">
      <path d="M16.5 8.31002V9.00002C16.4991 10.6173 15.9754 12.191 15.007 13.4864C14.0386 14.7818 12.6775 15.7294 11.1265 16.1879C9.57557 16.6465 7.91794 16.5914 6.40085 16.031C4.88376 15.4705 3.58849 14.4346 2.70822 13.0778C1.82795 11.721 1.40984 10.1161 1.51626 8.50226C1.62267 6.88844 2.24791 5.35227 3.29871 4.12283C4.34951 2.89338 5.76959 2.03656 7.34714 1.68013C8.92469 1.3237 10.5752 1.48677 12.0525 2.14502" stroke="#0D1D39" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M16.5 3L9 10.5075L6.75 8.2575" stroke="#0D1D39" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
    </g>
    <defs>
      <clipPath id="clip0_4174_9883">
        <rect width="18" height="18" fill="white" />
      </clipPath>
    </defs>
  </svg>)
}
